import { useEffect } from "react";
import { useLocation } from "react-router-dom";

export const useSkipPhoneVerification = () => {
  const location = useLocation();

  useEffect(() => {
    const skipPhoneVerification = new URLSearchParams(location.search).get(
      "skipPhoneVerification"
    );

    if (skipPhoneVerification) {
      sessionStorage.setItem("skipPhoneVerification", "true");
    }
  }, [location.search]);
};
